import React from "react"
import PropTypes from "prop-types"

import IconWithText from "@components/IconWithText"

const IconWithTextModule = ({
  title,
  titleClass,
  className,
  gridClassName,
  items,
}) => {
  const addBackgroundIfNeeded = className.includes("bg-") ? "" : "bg-white"
  return (
    <div className={`${className} ${addBackgroundIfNeeded}`}>
      <div className="mx-auto max-w-screen-fhd flex items-center flex-col">
        <h2
          className={`text-dblue font-inter text-20 
      xl:text-40 text-center leading-6 xl:leading-normal font-normal xl:font-medium mb-5 xl:mb-15 ${
        titleClass || ""
      }`}
        >
          {title}
        </h2>
        <ul className={`grid ${gridClassName}`}>
          {items.map(item => (
            <IconWithText key={item.text} {...item} />
          ))}
        </ul>
      </div>
    </div>
  )
}

IconWithTextModule.propTypes = {
  title: PropTypes.string,
  // an array of text and icon
  items: PropTypes.array,
  // use to control columns and responsiveness
  gridClassName: PropTypes.string,
  titleClass: PropTypes.string,
  className: PropTypes.string,
}

IconWithTextModule.defaultProps = {
  gridClassName: "grid-cols-2 gap-5 md:grid-cols-4 md:gap-4 xl:gap-8",
  titleClass: "text-center",
  className: "p-6 md:py-10 md:px-11 xl:p-25",
}

export default IconWithTextModule
